/* =========================================================
   SecondSpring — Buy box V2 (SecondSpring-style tiered offer)
   gift-unlock bar • savings copy • ATC with free gifts
   Bundle selection/pricing itself is handled by ss-theme-product.js;
   this file layers tier-aware behavior on top.
   ========================================================= */
(function () {
  'use strict';

  // Same presentment-currency formatting approach as ss-theme-product.js
  const _cfg = window.SS_THEME_CFG || {};
  let _nfInt = null, _nfDec = null;
  try {
    const base = { style: 'currency', currency: _cfg.currency || 'USD' };
    _nfInt = new Intl.NumberFormat(_cfg.locale || 'en', Object.assign({ minimumFractionDigits: 0, maximumFractionDigits: 0 }, base));
    _nfDec = new Intl.NumberFormat(_cfg.locale || 'en', Object.assign({ minimumFractionDigits: 2, maximumFractionDigits: 2 }, base));
  } catch (e) { _nfInt = _nfDec = null; }
  // Whole dollars drop the ".00"; anything fractional keeps 2 digits ($504.90, not $504.9)
  const money = n => {
    const whole = Math.round(n * 100) % 100 === 0;
    const nf = whole ? _nfInt : _nfDec;
    return nf ? nf.format(n) : '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  };
  const cents = c => money((+c || 0) / 100);
  const roundedCents = c => cents(Math.round((+c || 0) / 100) * 100);

  function init() {
    const root = document.querySelector('.bb-v2');
    if (!root) return;
    const bundles = [...root.querySelectorAll('.bundle')];
    if (!bundles.length) return;
    const cfg = window.SS_THEME_BB2 || {};
    const subscriptionOnly = false;
    const checkbox = root.querySelector('[data-subscription-checkbox]');
    checkbox.checked = false;
    const subscribed = () => checkbox.checked;
    const gifts = cfg.gifts || [];
    const gbItems = [...root.querySelectorAll('.gb-item')];

    const selectedBundle = () => bundles.find(b => b.getAttribute('aria-checked') === 'true');
    const tierOf = () => {
      const s = selectedBundle();
      return s ? +s.dataset.tier || 1 : 1;
    };

    // Subscription price is the default display (ss-theme-product.js boots in
    // 'sub' mode); one-time price backs the express-checkout link below.
    const priceOf = b => subscribed() && b.dataset.plan ? (+b.dataset.sub || +b.dataset.once || 0) : (+b.dataset.once || 0);

    // SecondSpring-style savings copy vs the anchor compare price: "You save $X"
    // per card, and the anchor (not the one-time price) as the strikethrough.
    // Overwrites what ss-theme-product.js paints once at its init.
    function paintSavings() {
      bundles.forEach(b => {
        const compare = +b.dataset.compare || +b.dataset.once || 0;
        b.querySelector('.b-price').textContent = cents(priceOf(b));
        b.querySelector('.b-name').textContent = b.querySelector('.b-name').dataset.subscriptionLabel;
        const save = compare - priceOf(b);
        const saveEl = b.querySelector('.b-save');
        const wasEl = b.querySelector('.b-was');
        if (saveEl) {
          saveEl.textContent = 'You save ' + (compare > 0 ? Math.max(0, Math.round(save / compare * 100)) : 0) + '%';
          saveEl.title = 'Compared with the regular price';
          saveEl.style.display = '';
        }
        if (wasEl) {
          if (compare > priceOf(b)) { wasEl.textContent = cents(compare); wasEl.style.display = ''; }
          else wasEl.style.display = 'none';
        }
      });
    }

    // Selected-tier copy: sale pill ("SUMMER SALE - Save $X"), anchor
    // strikethrough next to the price, and the one-time purchase price.
    // Overwrites the "% OFF"/one-time-was text ss-theme-product.js paints on selection.
    function paintSelected() {
      const s = selectedBundle();
      if (!s) return;
      const stickyPlan = document.getElementById('stickyPlan');
      if (stickyPlan) stickyPlan.textContent = s.dataset.months + '-month supply · ' + (subscribed() && s.dataset.plan ? 'every 28 days' : 'one-time');
      const stickyImage = document.querySelector('[data-sticky-bundle-image]');
      const bundleImage = s.querySelector('.b-media img');
      if (stickyImage && bundleImage) stickyImage.src = bundleImage.currentSrc || bundleImage.src;
      const refill = root.querySelector('[data-subscription-refill]');
      if (refill) refill.textContent = s.dataset.plan
        ? 'Refills every 28 days'
        : 'Subscription unavailable';
      const giftBenefit = root.querySelector('[data-subscription-gifts]');
      if (giftBenefit) giftBenefit.hidden = !s.dataset.plan || !gifts.slice(0, Math.max(0, tierOf() - 1)).some(g => g && g.id);
      const compare = +s.dataset.once || 0;
      root.dataset.purchaseMode = subscribed() ? 'sub' : 'once';
      root.querySelector('.pl-label').textContent = subscribed() ? cfg.subscriptionLabel : cfg.onceLabel;
      root.querySelector('[data-checkbox-title]').textContent = cfg.checkboxTitle.replace('[saving]', cents(compare - (+s.dataset.sub || compare)));
      checkbox.disabled = !(s.dataset.plan && s.dataset.sub);
      ['atcNow','stickyNow'].forEach(id => { const el=document.getElementById(id); if(el) el.textContent=cents(priceOf(s)); });
      const stickyWas=document.getElementById('stickyWas');
      if(stickyWas){ stickyWas.textContent=cents(+s.dataset.compare || compare); stickyWas.style.display=(+s.dataset.compare || compare)>priceOf(s) ? '' : 'none'; }
      const buttonCompare = +s.dataset.compare || compare;
      const save = buttonCompare - priceOf(s);
      const off = document.getElementById('atcOff');
      if (off) {
        if (save > 0) { off.textContent = (cfg.saleLabel || 'SALE') + ' - Save ' + cents(save); off.style.display = ''; }
        else off.style.display = 'none';
      }
      const was = document.getElementById('atcWas');
      if (was) {
        if (buttonCompare > priceOf(s)) { was.textContent = cents(buttonCompare); was.style.display = ''; }
        else was.style.display = 'none';
      }
      const buttonWas = document.getElementById('atcButtonWas');
      const buttonNow = document.getElementById('atcButtonNow');
      if (buttonWas) {
        if (buttonCompare > priceOf(s)) { buttonWas.textContent = cents(buttonCompare); buttonWas.style.display = ''; }
        else buttonWas.style.display = 'none';
      }
      if (buttonNow) buttonNow.textContent = cents(priceOf(s));
      const otp = document.getElementById('otpPrice');
      if (otp) otp.textContent = cents(+s.dataset.once || 0);
      const shipping = root.querySelector('[data-otp-shipping]');
      const currencyRate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      if (shipping) shipping.textContent = cents(Math.round(495 * currencyRate));
    }

    // Tier hero: selecting tier 2/3 swaps the featured slide + first thumb
    // to that tier's composite image; tier 1 restores the original.
    const tierHero = cfg.tierHero || {};
    let heroOrig = null;
    function paintHero() {
      const track = document.getElementById('galTrack');
      const slideImg = track && track.querySelector('.gal-slide img');
      const thumbBtn = root.querySelector('.gal-thumb');
      const thumbImg = thumbBtn && thumbBtn.querySelector('img');
      if (!slideImg || !thumbImg) return;
      if (!heroOrig) heroOrig = {
        src: slideImg.src, srcset: slideImg.getAttribute('srcset'),
        thumbSrc: thumbImg.src, full: thumbBtn.dataset.full || ''
      };
      const url = tierHero[String(tierOf())];
      const changed = url ? slideImg.src !== url : slideImg.src !== heroOrig.src;
      if (url) {
        slideImg.src = url; slideImg.removeAttribute('srcset');
        thumbImg.src = url; thumbBtn.dataset.full = url;
      } else {
        slideImg.src = heroOrig.src;
        if (heroOrig.srcset) slideImg.setAttribute('srcset', heroOrig.srcset);
        thumbImg.src = heroOrig.thumbSrc; thumbBtn.dataset.full = heroOrig.full;
      }
      // bring the featured slide into view so the swap is visible
      if (changed && track) track.scrollTo({ left: 0, behavior: 'smooth' });
    }

    function paintGifts() {
      paintSavings();
      const t = tierOf();
      gbItems.forEach(it => it.classList.toggle('locked', t < +it.dataset.unlock));
      paintSelected();
      paintHero();
    }

    // React to any selection change ss-theme-product.js makes (click, keyboard,
    // init). Observer callbacks run after selectBundle/paintATC complete,
    // so the copy rewrites above always win.
    const mo = new MutationObserver(paintGifts);
    bundles.forEach(b => mo.observe(b, { attributes: true, attributeFilter: ['aria-checked'] }));

    // Pre-select a tier: ?count=N (SecondSpring-style link param) wins, then the
    // section's default tier. ss-theme-product.js's own ?bundle=N param is respected.
    // The click only lands once ss-theme-product.js has bound its handlers, and
    // script ordering isn't guaranteed — verify via aria-checked and retry.
    const params = new URLSearchParams(location.search);
    const count = +params.get('count');
    let want = null;
    if (count && bundles[count - 1]) want = bundles[count - 1];
    else if (!params.get('bundle') && cfg.defaultTier && bundles[cfg.defaultTier - 1]) want = bundles[cfg.defaultTier - 1];
    (function preselect(tries) {
      if (!want || want.getAttribute('aria-checked') === 'true') return;
      want.click();
      if (want.getAttribute('aria-checked') !== 'true' && tries > 0) setTimeout(() => preselect(tries - 1), 60);
    })(20);
    if (subscriptionOnly) {
      bundles.forEach(b => {
        const available = !!(b.dataset.plan && b.dataset.sub);
        b.classList.toggle('subscription-unavailable', !available);
        b.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    }
    checkbox.addEventListener('change', paintGifts);
    window.addEventListener('pageshow', () => { checkbox.checked = false; paintGifts(); });
    paintSavings();
    paintGifts();

    // Gift line items the selected tier unlocks (tier 2 → gift 1, tier 3 →
    // gifts 1+2; nulls = messaging-only gifts). Gifts deliberately have no
    // selling_plan: they ship with the initial order only, never on renewals.
    const giftItems = () => {
      const t = tierOf();
      return gifts.slice(0, Math.max(0, t - 1)).filter(g => g && g.id).map(g => ({ id: g.id, quantity: 1 }));
    };

    // Add once, open the cart, and keep Shopify errors visible beside the button.
    let cartRequestPending = false;
    async function expressCheckout(btn, items) {
      if (btn.disabled || cartRequestPending) return;
      cartRequestPending = true;
      const cartButtons = [...root.querySelectorAll('[data-add-v2], [data-otp]'), document.getElementById('stickyBuy')].filter(Boolean);
      cartButtons.forEach(button => { button.disabled = true; });
      let error = btn.nextElementSibling;
      if (!error || !error.matches('[data-cart-error]')) {
        error = document.createElement('p');
        error.dataset.cartError = '';
        error.setAttribute('role', 'alert');
        error.style.cssText = 'color:var(--oxblood);font-size:14px;line-height:1.5;margin:12px 0';
        btn.insertAdjacentElement('afterend', error);
      }
      error.hidden = true;
      error.textContent = '';
      btn.disabled = true;
      btn.classList.add('is-loading');
      const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
      let added = false;
      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
        added = true;
        if (window.SSTheme && SSTheme.refreshCart && SSTheme.openDrawer) {
          await SSTheme.refreshCart();
          SSTheme.openDrawer();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        if (added) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } else {
          error.textContent = e.message || 'Could not add to cart. Please try again.';
          error.hidden = false;
        }
      } finally {
        cartRequestPending = false;
        cartButtons.forEach(button => { button.disabled = false; });
        btn.classList.remove('is-loading');
      }
    }

    // Add to cart: selected variant on its subscription plan (default) +
    // the tier's free gifts, then open the cart.
    [...root.querySelectorAll('[data-add-v2]'), ...document.querySelectorAll('#stickyBuy[data-add-v2]')].forEach(btn => btn.addEventListener('click', () => {
      const s = selectedBundle();
      if (!s || !s.dataset.variant) return;
      const item = { id: +s.dataset.variant, quantity: 1 };
      if (subscriptionOnly) {
        if (!(s.dataset.plan && s.dataset.sub)) return;
        item.selling_plan = +s.dataset.plan;
      } else if (subscribed() && s.dataset.plan && s.dataset.sub) {
        item.selling_plan = +s.dataset.plan;
      }
      expressCheckout(btn, [item].concat(subscribed() ? giftItems() : []));
    }));

    // One Time Purchase: same flow without the selling plan.
    root.querySelectorAll('[data-otp]').forEach(btn => btn.addEventListener('click', () => {
      const s = selectedBundle();
      if (!s || !s.dataset.variant) return;
      expressCheckout(btn, [{ id: +s.dataset.variant, quantity: 1 }]);
    }));

    // Animate the stock bar fill on load
    const fill = root.querySelector('.sa-fill');
    if (fill) requestAnimationFrame(() => requestAnimationFrame(() => fill.classList.add('go')));
  }

  // Deferred scripts run at readyState 'interactive', and ss-theme-product.js
  // (which binds the bundle click handlers) executes after this file in
  // document order — so wait for DOMContentLoaded before layering on top.
  if (document.readyState === 'complete') init();
  else {
    let done = false;
    const run = () => { if (!done) { done = true; init(); } };
    document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
  }
})();
